import 'react-phone-number-input/style.css'
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import { Value } from 'react-phone-number-input';
import Input from 'react-phone-number-input/input'

import { TranslationFuncProp } from '../../../common/types/prop-types/common';
import iconCancelar from '../../assets/images/icons/Cinzentos/cancelar.svg';
import iconLapisEditar from '../../assets/images/icons/Cinzentos/lapisEditar.svg';
import cssForms from '../../assets/scss/Forms.scss';
import CustomerInfoContainer, { CustomerInfoContainerProps, CustomerInfoProps } from './containers/CustomerInfoContainer';
// import DeleteAccount from './DeleteAccount';

const ReadState: React.FC<CustomerInfoProps & TranslationFuncProp> = (props) => {
    if (props.editState.isEditing) {
        return null;
    }
    return (
        <React.Fragment>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-pessoais', 'label-space'])}>{props.t('profile:customerInfo.personalInfo')}</label>
            </div>
            <div className={classNames(['cell', 'medium-4'])}>
                <label>{props.t('signup:formFields.firstNameSimple')}</label>
                <span>{props.firstName.inputProps.value ? props.firstName.inputProps.value : '–'}</span>
            </div>
            <div className={classNames(['cell', 'medium-4'])}>
                <label>{props.t('signup:formFields.lastName')}</label>
                <span>{props.lastName.inputProps.value ? props.lastName.inputProps.value : '–'}</span>
            </div>
            <div className={classNames(['cell', 'medium-4'])}>
                <label>{props.t('signup:formFields.nif')}</label>
                <span>{props.nif.inputProps.value ? props.nif.inputProps.value : '–'}</span>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <hr />
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-email', 'label-space'])}>{props.t('profile:customerInfo.bmwId.header')}</label>
            </div>
            <div className={classNames(['cell', 'medium-4'])}>
                <span>{props.t('profile:customerInfo.bmwId.disclaimer')}</span>
            </div>
            <div className={classNames(['cell', 'auto'])}>
                <label>{props.t('profile:customerInfo.bmwId.field')}</label>
                <span>{props.email}</span>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <hr />
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-telefones', 'label-space'])}>{props.t('profile:customerInfo.phone.header')}</label>
            </div>
            <div className={classNames(['cell', 'medium-4'])}>
                <span>{props.t('profile:customerInfo.phone.disclaimer')}</span>
            </div>
            <div className={classNames(['cell', 'auto'])}>
                <label>{props.t('profile:customerInfo.phone.phoneField')}</label>
                <span>{props.phoneNumber.value ? props.phoneNumber.value : '–'}</span>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <hr />
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-morada', 'label-space'])}>{props.t('profile:customerInfo.address.header')}</label>
            </div>
            <div className={'cell'}>
                <div className={classNames(['grid-x', 'grid-margin-x', 'grid-margin-y'])}>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <span>{props.t('profile:customerInfo.address.disclaimer')}</span>
                    </div>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <label>{props.t('profile:customerInfo.address.streetField')}</label>
                        <span>{props.address.inputProps.value ? props.address.inputProps.value : '–'}</span>
                    </div>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <label>{props.t('signup:formFields.addressNumber')}</label>
                        <span>{props.addressNumber.inputProps.value ? props.addressNumber.inputProps.value : '–'}</span>
                    </div>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <label>{props.t('signup:formFields.addressFloor')}</label>
                        <span>{props.addressFloor.inputProps.value ? props.addressFloor.inputProps.value : '–'}</span>
                    </div>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <label>{props.t('signup:formFields.postalCode')}</label>
                        <span>{props.postalCode.inputProps.value ? props.postalCode.inputProps.value : '–'}</span>
                    </div>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <label>{props.t('signup:formFields.city')}</label>
                        <span>{props.city.inputProps.value ? props.city.inputProps.value : '–'}</span>
                    </div>
                </div>
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <hr />
            </div>
        </React.Fragment>
    );
};

const EditState: React.FC<CustomerInfoProps & TranslationFuncProp> = (props) => {
    if (!props.editState.isEditing) {
        return null;
    }
    return (
        <React.Fragment>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-pessoais', 'label-space'])}>{props.t('profile:customerInfo.personalInfo')}</label>
            </div>
            <div className={classNames(['cell', 'medium-4'])}>
                <label className={'label-space'}>{props.t('signup:formFields.firstNameSimple')}</label>
                <input type="text" {...props.firstName.inputProps} />
                {props.firstName.errorText && <div className="error-message">{props.firstName.errorText}</div>}
            </div>
            <div className={classNames(['cell', 'medium-4'])}>
                <label className={'label-space'}>{props.t('signup:formFields.lastName')}</label>
                <input type="text" {...props.lastName.inputProps} />
                {props.lastName.errorText && <div className="error-message">{props.lastName.errorText}</div>}
            </div>
            <div className={classNames(['cell', 'medium-4'])}>
                <label className={'label-space'}>{props.t('signup:formFields.nif')}</label>
                <input type="text" {...props.nif.inputProps} />
                {props.nif.errorText && <div className="error-message">{props.nif.errorText}</div>}
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <hr />
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-telefones', 'label-space'])}>{props.t('profile:customerInfo.phone.header')}</label>
            </div>
            <div className={classNames(['cell', 'medium-4'])}>
                <label className={'label-space'}>{props.t('profile:customerInfo.phone.phoneField')}</label>
                <Input
                    inputClassName={'foundation-input-force'}
                    defaultCountry="PT"
                    value={props.phoneNumber.value as Value}
                    onChange={(phone) => props.phoneNumber.onChange(phone || '')}
                />
                {props.phoneNumber.errorText && <div className="error-message">{props.phoneNumber.errorText}</div>}
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <hr />
            </div>
            <div className={classNames(['cell', 'medium-12'])}>
                <label className={classNames(['informacoes-morada', 'label-space'])}>{props.t('profile:customerInfo.address.header')}</label>
            </div>
            <div className={'cell'}>
                <div className={classNames(['grid-x', 'grid-margin-x'])}>
                    <div className={classNames(['cell', 'medium-8'])}>
                        <label className={'label-space'}>{props.t('profile:customerInfo.address.streetField')}</label>
                        <input type="text" {...props.address.inputProps} />
                        {props.address.errorText && <div className="error-message">{props.address.errorText}</div>}
                    </div>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <label className={'label-space'}>{props.t('signup:formFields.addressNumber')}</label>
                        <input type="text" {...props.addressNumber.inputProps} />
                        {props.addressNumber.errorText && <div className="error-message">{props.addressNumber.errorText}</div>}
                    </div>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <label className={'label-space'}>{props.t('signup:formFields.addressFloor')}</label>
                        <input type="text" {...props.addressFloor.inputProps} />
                        {props.addressFloor.errorText && <div className="error-message">{props.addressFloor.errorText}</div>}
                    </div>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <label className={'label-space'}>{props.t('signup:formFields.postalCode')}</label>
                        <InputMask type="text" {...props.postalCode.inputProps} maskChar="" mask="****-***" placeholder="XXXX-XXX" className={classNames([cssForms.inputUppercase])} />
                        {props.postalCode.errorText && <div className="error-message">{props.postalCode.errorText}</div>}
                    </div>
                    <div className={classNames(['cell', 'medium-4'])}>
                        <label className={'label-space'}>{props.t('signup:formFields.city')}</label>
                        <input type="text" {...props.city.inputProps} />
                        {props.city.errorText && <div className="error-message">{props.city.errorText}</div>}
                    </div>
                </div>
            </div>
            <div className={'cell'}>
                {props.submitErrorText && <div className="error-message">{props.submitErrorText}</div>}
                <div className={classNames(['small', 'button-group', 'dados-pacotes'])}>
                    <button className={classNames(['button', 'alterar'])} {...props.btnEditCustomerInfo}>{props.btnEditCustomerInfo.disabled ? props.t('loadingText') : props.t('change')}</button>
                    <button className={classNames(['button', 'cancelar', 'margin-left-1'])} onClick={props.editState.changeEditMode}>{props.t('cancel')}</button>
                </div>
            </div>
        </React.Fragment>
    );
};

const CustomerInfo: React.FC<CustomerInfoContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    return (
        <CustomerInfoContainer {...containerProps} t={t} >
            {(props: CustomerInfoProps) => {
                return (
                    <React.Fragment>
                        <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns', 'edit-area'])}>
                            <div className={'edit-area'}>
                                <p className={classNames(['margin-left-0', 'margin-top-1', 'float-left'])}>{t('profile:canEdit')}</p>
                                <div className={classNames(['tabs-title', 'float-right'])}>
                                    <a onClick={props.editState.changeEditMode}>
                                        <img src={props.editState.isEditing ? iconCancelar : iconLapisEditar} alt={props.editState.isEditing ? t(`common:cancel`) : t(`common:edit`)} />
                                        {props.editState.isEditing ? t(`common:cancel`) : t(`common:edit`)}
                                    </a>
                                </div>
                            </div>
                            <hr />
                        </div>
                        <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                            <div className={'tabs-content'} data-tabs-content="collapsing-tabs">
                                <div className={classNames(['tabs-panel', 'is-active'])} id="dados-pessoais">
                                    <div className={classNames(['grid-container', 'fluid'])}>
                                        <div className={classNames(['grid-x', 'grid-margin-x'])}>
                                            <EditState
                                                t={t}
                                                {...props}
                                            />
                                            <ReadState
                                                t={t}
                                                {...props}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* !props.editState.isEditing && <DeleteAccount /> */}
                            </div>
                        </div>
                    </React.Fragment>
                );
            }}
        </CustomerInfoContainer>
    );
};

export default CustomerInfo;
